import '../css/mobile.scss'
import '../css/splide.min.css'
import {EntryShared, socket, uiGameManager} from '../../shared/scripts/EntryShared.ts'
import {UIMMobileWebviewCommunication} from './ui_mobile_communication/UIMMobileWebviewCommunication.ts'
import {UIMSocketEventHandler} from './UIMSocketEventHandler.ts'
import {UIMManager} from './ui_html/UIMManager.ts'
import {UIMNotificationController} from './notifications/UIMNotificationController.ts'
import {UIMGameManager} from './ui_game/UIMGameManager.ts'
// eslint-disable-next-line no-restricted-imports
import {UIWGameManager} from '../../web/scripts/ui_game/UIWGameManager.ts'
import {UIUtilsEjsVariables} from '../../shared/scripts/UIUtilsEjsVariables.ts'
import {UIMDeviceHandler} from './ui_html/UIMDeviceHandler.ts'
import {UIMGameReviewController} from './ui_popup/UIMGameReviewController.ts'
import {EntryMobileUrlParameterController} from './EntryMobileUrlParameterController.ts'
import {ClientUserState} from '../../shared/scripts/ClientUserState.ts'
import {UIMGeneralServicesController} from './UIMGeneralServicesController.ts'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums.ts'
import {registerMobileRoomClientHandlers} from './MobileRoomClientHandlers.ts'
import {UIAjaxWrapper} from '../../shared/scripts/network/UIAjaxWrapper.ts'
import {UIAPIEndpoints} from '../../shared/scripts/network/UIAPIEndpoints.ts'
import {registerSharedRoomClientHandlers} from '../../shared/scripts/SharedRoomClientHandlers.ts'

export let uiManager: UIMManager
class EntryMobile extends EntryShared {
    constructor() {
        super()
        UIMDeviceHandler.initSavedInfoFromDevice()
        void this.initialize()
    }

    async initialize() {
        await ClientUserState.refresh()
        new UIMMobileWebviewCommunication()

        await this.initializeSoundAndVersionController()

        await EntryShared.initializeEntry()
        if(ClientUserState.userState?.isLoggedIn) void UIAjaxWrapper.postRequestWhenReady(UIAPIEndpoints.apiReactivationMessage(), undefined, {platform: 'mobile'})

        this.webGLCheck()

        uiManager = new UIMManager()
        this.initializeUIManagerEvents(uiManager.uiManagerEvents)

        const gameManager = this.getGameManager()
        this.initializeGameManager(gameManager)
        EntryShared.initializeNotification(new UIMNotificationController())

        const generalServicesController = new UIMGeneralServicesController(uiManager)
        const socketActionController = new UIMSocketEventHandler(uiGameManager, uiManager, generalServicesController)
        EntryShared.initializeSocket(socketActionController, () => uiManager.sceneController.scene == UIMSceneEnum.Game)

        registerSharedRoomClientHandlers(socket.roomClient)
        registerMobileRoomClientHandlers(socket.roomClient, uiManager)

        uiManager.init()
        generalServicesController.init()

        socket.connect()

        new UIMGameReviewController(gameManager)
        this.completeInitialization()
        EntryMobileUrlParameterController.loadParameterEvents()
        UIMDeviceHandler.sendUserIdForNotifications()
    }

    // eslint-disable-next-line class-methods-use-this
    private getGameManager() {
        return UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? new UIMGameManager(uiManager.adController) : new UIWGameManager(uiManager.adController)
    }
}

new EntryMobile()
